<div class="back-to-home rounded d-none d-sm-block">
  <a routerLink="/index" class="btn btn-icon btn-primary">
    <i-feather name="home" class="icons"></i-feather>
  </a>
</div>

<!-- Hero Start -->
<section class="cover-user bg-white">
  <div class="container-fluid px-0">
    <div class="row no-gutters position-relative">
      <div class="col-lg-4 cover-my-30 order-2">
        <div class="cover-user-img d-flex align-items-center">
          <div class="row">
            <div class="col-12">
              <div class="card login-page border-0" style="z-index: 1">
                <div class="card-body p-0">
                  <h4 class="card-title text-center">Login</h4>
                  <form class="login-form mt-4">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label class="form-label">Your Email <span class="text-danger">*</span></label>
                          <div class="form-icon position-relative">
                            <i-feather name="user" class="fea icon-sm icons"></i-feather>
                            <input type="email" class="form-control ps-5" placeholder="Email" name="email" required="">
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12">
                        <div class="mb-3">
                          <label class="form-label">Password <span class="text-danger">*</span></label>
                          <div class="form-icon position-relative">
                            <i-feather name="key" class="fea icon-sm icons"></i-feather>
                            <input type="password" class="form-control ps-5" placeholder="Password" required="">
                          </div>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12">
                        <div class="d-flex justify-content-between">
                          <div class="mb-3">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                              <label class="form-check-label" for="flexCheckDefault">Remember me</label>
                            </div>
                          </div>
                          <p class="forgot-pass mb-0"><a routerLink="/auth-cover-re-password"
                              class="text-dark fw-bold">Forgot password ?</a></p>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12 mb-0">
                        <div class="d-grid">
                          <button class="btn btn-primary">Sign in</button>
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-lg-12 mt-4 text-center">
                        <h6>Or Login With</h6>
                        <div class="row">
                          <div class="col-6 mt-3">
                            <div class="d-grid">
                              <a href="javascript:void(0)" class="btn btn-light"><i
                                  class="mdi mdi-facebook text-primary"></i> Facebook</a>
                            </div>
                          </div>
                          <!--end col-->

                          <div class="col-6 mt-3">
                            <div class="d-grid">
                              <a href="javascript:void(0)" class="btn btn-light"><i
                                  class="mdi mdi-google text-danger"></i> Google</a>
                            </div>
                          </div>
                          <!--end col-->
                        </div>
                      </div>
                      <!--end col-->

                      <div class="col-12 text-center">
                        <p class="mb-0 mt-3"><small class="text-dark me-2">Don't have an account ?</small> <a
                            routerLink="/auth-cover-signup" class="text-dark fw-bold">Sign Up</a></p>
                      </div>
                      <!--end col-->
                    </div>
                    <!--end row-->
                  </form>
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div> <!-- end about detail -->
      </div> <!-- end col -->

      <div class="col-lg-8 offset-lg-4 padding-less img order-1"
        style="background-image:url('assets/images/user/01.jpg')" data-jarallax='{"speed": 0.5}'></div><!-- end col -->
    </div>
    <!--end row-->
  </div>
  <!--end container fluid-->
</section>
<!--end section-->
<!-- Hero End -->